import React, { useState } from "react";
import { Accordion, AccordionSummary, AccordionDetails, Typography, Box, Grid, Card } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { DecorativeCorner } from "../../common/DecorativeCorner";
import { styles } from "../../styles/styles";
import Header from "../Header";
import Footer from "../Footer";
import { Link } from "react-router-dom";
import { FontStyles } from "../../styles/FontStyles";

const profileDetails1 = [
    { loginto: `https://annapurnamatrimony.com/` },
    { title: "Free Registration" },
    { par: " Provide name, surname, mobile number, email Id, Date of Birth, Gender and few more details. Click on Register link and you will have to enter on a couple of pages the details of the person intending to get married. After you submit your information, your profile will be automatically created and you shall be given a 'Annapurna Marriages ID' generated for future references and login purposes. " },

];

const Faq = () => {
    const [expanded, setExpanded] = useState(false);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    return (
        <>
            <Box>
                <Header />
            </Box>
            <Box sx={{ marginTop: { xs: "29%", sm: "10%", md: "10%", lg: "10%", xl: "10%" } }}>
                <Box sx={{ margin: "50px" }}>
                    <Typography variant="h4" component="h1" sx={styles.heading}>
                        Frequently Asked Questions
                    </Typography>
                    <Accordion expanded={expanded === "panel1"} onChange={handleChange("panel1")} sx={{ backgroundColor: "rgba(247, 242, 242, 0.8)", mb: 2, color: "black" }}>
                        <AccordionSummary expandIcon={expanded === "panel1" ? <RemoveIcon sx={{ color: "black" }} /> : <AddIcon sx={{ color: "black" }} />}>
                            <Typography sx={{ ...FontStyles.faqfontstyle }}>
                                How to Register ?
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Card sx={{ ...styles.faqcard, height: "auto", padding: 4, borderRadius: "5px" }}>
                                <DecorativeCorner sx={{ top: -20, left: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ top: -20, right: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ bottom: -20, right: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ bottom: -20, left: -20, transform: "rotate(0deg)" }} />

                                <Box sx={{
                                    width: "100%", margin: "auto", backgroundColor: "white", border: "2px solid #B56E2C",
                                    borderRadius: "10px", boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.1)",
                                    padding: "30px"
                                }}>
                                    <Grid container spacing={2}>
                                        {profileDetails1.map((item, index) => (
                                            <React.Fragment key={index}>
                                                {item.loginto && (
                                                    <Grid item xs={12} sm={12} sx={{ display: "flex", justifyContent: "space-between" }}>
                                                        <Typography sx={{ ...FontStyles.faqcontent }}>
                                                            Login To :    <a href={item.loginto} target="_blank" rel="noopener noreferrer" style={{
                                                                textDecoration: "none",
                                                                color: "  #B56E2C"
                                                            }}>

                                                                {item.loginto}
                                                            </a>
                                                        </Typography>
                                                    </Grid>
                                                )}

                                                {item.title && (
                                                    <Grid item xs={12} md={12}>
                                                        <Typography sx={{ ...FontStyles.faqcontent }}>
                                                            {item.title}
                                                        </Typography>
                                                    </Grid>
                                                )}

                                                {item.par && (
                                                    <Grid item xs={12} md={12}>
                                                        <Typography sx={{ ...FontStyles.faqphg }}>
                                                            {item.par}
                                                        </Typography>
                                                    </Grid>
                                                )}
                                            </React.Fragment>
                                        ))}
                                    </Grid>
                                </Box>
                            </Card>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion expanded={expanded === "panel2"} onChange={handleChange("panel2")} sx={{ backgroundColor: "rgba(247, 242, 242, 0.8)", mb: 2, color: "black" }}>
                        <AccordionSummary
                            expandIcon={expanded === "panel2" ? <RemoveIcon sx={{ color: "black" }} /> : <AddIcon sx={{ color: "black" }} />}
                        >
                            <Typography sx={{ ...FontStyles.faqfontstyle }}>
                                Can I use same Email-Id for multiple registrations ?
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Card sx={{ ...styles.faqcard, height: "auto", width: "100%", padding: 4, borderRadius: "5px" }}>
                                <DecorativeCorner sx={{ top: -20, left: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ top: -20, right: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ bottom: -20, right: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ bottom: -20, left: -20, transform: "rotate(0deg)" }} />
                                <Box sx={{
                                    width: "100%", margin: "auto", backgroundColor: "white", border: "2px solid #B56E2C",
                                    borderRadius: "10px", boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.1)", padding: "30px", textAlign: "start"
                                }}>
                                    <Typography sx={{ ...FontStyles.faqphg }}>

                                        No, you cannot use same e-mail Id for multiple accounts. We are allowing unique email for every single account
                                    </Typography>
                                </Box>
                            </Card>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion expanded={expanded === "panel3"} onChange={handleChange("panel3")} sx={{ backgroundColor: "rgba(247, 242, 242, 0.8)", mb: 2, color: "black" }}>
                        <AccordionSummary
                            expandIcon={expanded === "panel3" ? <RemoveIcon sx={{ color: "black" }} /> : <AddIcon sx={{ color: "black" }} />}
                        >
                            <Typography sx={{ ...FontStyles.faqfontstyle }}>
                                What is Community Profiles?
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Card sx={{ ...styles.faqcard, height: "auto", width: "100%", padding: 4, borderRadius: "5px" }}>
                                <DecorativeCorner sx={{ top: -20, left: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ top: -20, right: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ bottom: -20, right: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ bottom: -20, left: -20, transform: "rotate(0deg)" }} />
                                <Box sx={{
                                    width: "100%", margin: "auto", backgroundColor: "white", border: "2px solid #B56E2C",
                                    borderRadius: "10px", boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.1)", padding: "30px", textAlign: "start"
                                }}>
                                    <Typography sx={{ ...FontStyles.faqphg }}>

                                        nothing
                                    </Typography>
                                </Box>
                            </Card>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion expanded={expanded === "panel4"} onChange={handleChange("panel4")} sx={{ backgroundColor: "rgba(247, 242, 242, 0.8)", mb: 2, color: "black" }}>
                        <AccordionSummary
                            expandIcon={expanded === "panel4" ? <RemoveIcon sx={{ color: "black" }} /> : <AddIcon sx={{ color: "black" }} />}
                        >
                            <Typography sx={{ ...FontStyles.faqfontstyle }}>
                                What is filter option in community profiles ?
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Card sx={{ ...styles.faqcard, height: "auto", width: "100%", padding: 4, borderRadius: "5px" }}>
                                <DecorativeCorner sx={{ top: -20, left: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ top: -20, right: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ bottom: -20, right: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ bottom: -20, left: -20, transform: "rotate(0deg)" }} />
                                <Box sx={{
                                    width: "100%", margin: "auto", backgroundColor: "white", border: "2px solid #B56E2C",
                                    borderRadius: "10px", boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.1)", padding: "30px", textAlign: "start"
                                }}>
                                    <Typography sx={{ ...FontStyles.faqphg }}>

                                        Select your preferred state, city, marital status and click on Filter option. You will get only those profiles according to filtered options.
                                    </Typography>
                                </Box>
                            </Card>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion expanded={expanded === "panel5"} onChange={handleChange("panel5")} sx={{ backgroundColor: "rgba(247, 242, 242, 0.8)", mb: 2, color: "black" }}>
                        <AccordionSummary
                            expandIcon={expanded === "panel5" ? <RemoveIcon sx={{ color: "black" }} /> : <AddIcon sx={{ color: "black" }} />}
                        >
                            <Typography sx={{ ...FontStyles.faqfontstyle }}>
                                How do I edit my Profile?                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Card sx={{ ...styles.faqcard, height: "auto", width: "100%", padding: 4, borderRadius: "5px" }}>
                                <DecorativeCorner sx={{ top: -20, left: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ top: -20, right: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ bottom: -20, right: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ bottom: -20, left: -20, transform: "rotate(0deg)" }} />
                                <Box sx={{
                                    width: "100%", margin: "auto", backgroundColor: "white", border: "2px solid #B56E2C",
                                    borderRadius: "10px", boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.1)", padding: "30px", textAlign: "start"
                                }}>
                                    <Typography sx={{ ...FontStyles.faqphg }}>

                                        After Login, you can find the Edit Profile Option in the left side of the page. By clicking on it, you can edit your profile.
                                    </Typography>
                                </Box>
                            </Card>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion expanded={expanded === "panel6"} onChange={handleChange("panel6")} sx={{ backgroundColor: "rgba(247, 242, 242, 0.8)", mb: 2, color: "black" }}>
                        <AccordionSummary
                            expandIcon={expanded === "panel6" ? <RemoveIcon sx={{ color: "black" }} /> : <AddIcon sx={{ color: "black" }} />}
                        >
                            <Typography sx={{ ...FontStyles.faqfontstyle }}>
                                How to hide mobile number
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Card sx={{ ...styles.faqcard, height: "auto", width: "100%", padding: 4, borderRadius: "5px" }}>
                                <DecorativeCorner sx={{ top: -20, left: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ top: -20, right: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ bottom: -20, right: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ bottom: -20, left: -20, transform: "rotate(0deg)" }} />
                                <Box sx={{
                                    width: "100%", margin: "auto", backgroundColor: "white", border: "2px solid #B56E2C",
                                    borderRadius: "10px", boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.1)", padding: "30px", textAlign: "start"
                                }}>
                                    <Typography sx={{ ...FontStyles.faqphg }}>

                                        nothing
                                    </Typography>
                                </Box>
                            </Card>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion expanded={expanded === "panel7"} onChange={handleChange("panel7")} sx={{ backgroundColor: "rgba(247, 242, 242, 0.8)", mb: 2, color: "black" }}>
                        <AccordionSummary
                            expandIcon={expanded === "panel7" ? <RemoveIcon sx={{ color: "black" }} /> : <AddIcon sx={{ color: "black" }} />}
                        >
                            <Typography sx={{ ...FontStyles.faqfontstyle }}>
                                who viewes my mobile number
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Card sx={{ ...styles.faqcard, height: "auto", width: "100%", padding: 4, borderRadius: "5px" }}>
                                <DecorativeCorner sx={{ top: -20, left: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ top: -20, right: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ bottom: -20, right: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ bottom: -20, left: -20, transform: "rotate(0deg)" }} />
                                <Box sx={{
                                    width: "100%", margin: "auto", backgroundColor: "white", border: "2px solid #B56E2C",
                                    borderRadius: "10px", boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.1)", padding: "30px", textAlign: "start"
                                }}>
                                    <Typography sx={{ ...FontStyles.faqphg }}>

                                        nothing
                                    </Typography>
                                </Box>
                            </Card>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion expanded={expanded === "panel8"} onChange={handleChange("panel8")} sx={{ backgroundColor: "rgba(247, 242, 242, 0.8)", mb: 2, color: "black" }}>
                        <AccordionSummary
                            expandIcon={expanded === "panel8" ? <RemoveIcon sx={{ color: "black" }} /> : <AddIcon sx={{ color: "black" }} />}
                        >
                            <Typography sx={{ ...FontStyles.faqfontstyle }}>
                                how can i send note to the profile                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Card sx={{ ...styles.faqcard, height: "auto", width: "100%", padding: 4, borderRadius: "5px" }}>
                                <DecorativeCorner sx={{ top: -20, left: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ top: -20, right: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ bottom: -20, right: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ bottom: -20, left: -20, transform: "rotate(0deg)" }} />
                                <Box sx={{
                                    width: "100%", margin: "auto", backgroundColor: "white", border: "2px solid #B56E2C",
                                    borderRadius: "10px", boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.1)", padding: "30px", textAlign: "start"
                                }}>
                                    <Typography sx={{ ...FontStyles.faqphg }}>

                                        you can find send note button at the
                                        bottom of the profile,by clicking on it you can
                                        send a message to the patner
                                    </Typography>
                                </Box>
                            </Card>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion expanded={expanded === "panel9"} onChange={handleChange("panel9")} sx={{ backgroundColor: "rgba(247, 242, 242, 0.8)", mb: 2, color: "black" }}>
                        <AccordionSummary
                            expandIcon={expanded === "panel9" ? <RemoveIcon sx={{ color: "black" }} /> : <AddIcon sx={{ color: "black" }} />}
                        >
                            <Typography sx={{ ...FontStyles.faqfontstyle }}>
                                how can i view partners profile                             </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Card sx={{ ...styles.faqcard, height: "auto", width: "100%", padding: 4, borderRadius: "5px" }}>
                                <DecorativeCorner sx={{ top: -20, left: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ top: -20, right: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ bottom: -20, right: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ bottom: -20, left: -20, transform: "rotate(0deg)" }} />
                                <Box sx={{
                                    width: "100%", margin: "auto", backgroundColor: "white", border: "2px solid #B56E2C",
                                    borderRadius: "10px", boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.1)", padding: "30px", textAlign: "start"
                                }}>
                                    <Typography sx={{ ...FontStyles.faqphg }}>

                                        you can find view profile button at the
                                        bottom of the profile, by clicking on
                                        it you can view the partner profile
                                    </Typography>
                                </Box>
                            </Card>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion expanded={expanded === "panel10"} onChange={handleChange("panel10")} sx={{ backgroundColor: "rgba(247, 242, 242, 0.8)", mb: 2, color: "black" }}>
                        <AccordionSummary
                            expandIcon={expanded === "panel10" ? <RemoveIcon sx={{ color: "black" }} /> : <AddIcon sx={{ color: "black" }} />}
                        >
                            <Typography sx={{ ...FontStyles.faqfontstyle }}>
                                How to verify your moblie number                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Card sx={{ ...styles.faqcard, height: "auto", width: "100%", padding: 4, borderRadius: "5px" }}>
                                <DecorativeCorner sx={{ top: -20, left: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ top: -20, right: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ bottom: -20, right: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ bottom: -20, left: -20, transform: "rotate(0deg)" }} />
                                <Box sx={{
                                    width: "100%", margin: "auto", backgroundColor: "white", border: "2px solid #B56E2C",
                                    borderRadius: "10px", boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.1)", padding: "30px", textAlign: "start"
                                }}>
                                    <Typography sx={{ ...FontStyles.faqphg }}>

                                        after login , at the left side of the page , you can find mobile icon, by clicking on it , a pop-up appears asking to enter the verification code which is sent to your registered mobile number .once you enter the verification code youget a successful message that your mobile number is verified and the mobile icon turns green if your number is verified
                                    </Typography>
                                </Box>
                            </Card>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion expanded={expanded === "panel11"} onChange={handleChange("panel11")} sx={{ backgroundColor: "rgba(247, 242, 242, 0.8)", mb: 2, color: "black" }}>
                        <AccordionSummary
                            expandIcon={expanded === "panel11" ? <RemoveIcon sx={{ color: "black" }} /> : <AddIcon sx={{ color: "black" }} />}
                        >
                            <Typography sx={{ ...FontStyles.faqfontstyle }}>
                                How to verify email id ?
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Card sx={{ ...styles.faqcard, height: "auto", width: "100%", padding: 4, borderRadius: "5px" }}>
                                <DecorativeCorner sx={{ top: -20, left: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ top: -20, right: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ bottom: -20, right: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ bottom: -20, left: -20, transform: "rotate(0deg)" }} />
                                <Box sx={{
                                    width: "100%", margin: "auto", backgroundColor: "white", border: "2px solid #B56E2C",
                                    borderRadius: "10px", boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.1)", padding: "30px", textAlign: "start"
                                }}>
                                    <Typography sx={{ ...FontStyles.faqphg }}>

                                        after login at the left side of the page,you can find email id icon by clicking on it you get a verification link to your registered email id on clicking the verification link your email id gets verified
                                    </Typography>
                                </Box>
                            </Card>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion expanded={expanded === "panel12"} onChange={handleChange("panel12")} sx={{ backgroundColor: "rgba(247, 242, 242, 0.8)", mb: 2, color: "black" }}>
                        <AccordionSummary
                            expandIcon={expanded === "panel12" ? <RemoveIcon sx={{ color: "black" }} /> : <AddIcon sx={{ color: "black" }} />}
                        >
                            <Typography sx={{ ...FontStyles.faqfontstyle }}>
                                how to verify documents
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Card sx={{ ...styles.faqcard, height: "auto", width: "100%", padding: 4, borderRadius: "5px" }}>
                                <DecorativeCorner sx={{ top: -20, left: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ top: -20, right: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ bottom: -20, right: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ bottom: -20, left: -20, transform: "rotate(0deg)" }} />
                                <Box sx={{
                                    width: "100%", margin: "auto", backgroundColor: "white", border: "2px solid #B56E2C",
                                    borderRadius: "10px", boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.1)", padding: "30px", textAlign: "start"
                                }}>
                                    <Typography sx={{ ...FontStyles.faqphg }}>

                                        After login at the left side of the page you can find document icon when you click on it a pop-up appears asking you to upload documents for verification you can upload your scanned id proofs and get your documents verified
                                    </Typography>
                                </Box>
                            </Card>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion expanded={expanded === "panel13"} onChange={handleChange("panel13")} sx={{ backgroundColor: "rgba(247, 242, 242, 0.8)", mb: 2, color: "black" }}>
                        <AccordionSummary
                            expandIcon={expanded === "panel13" ? <RemoveIcon sx={{ color: "black" }} /> : <AddIcon sx={{ color: "black" }} />}
                        >

                            <Typography sx={{ ...FontStyles.faqfontstyle }}>
                                how can i add more photos to my profile ?
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Card sx={{ ...styles.faqcard, height: "auto", width: "100%", padding: 4, borderRadius: "5px" }}>
                                <DecorativeCorner sx={{ top: -20, left: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ top: -20, right: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ bottom: -20, right: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ bottom: -20, left: -20, transform: "rotate(0deg)" }} />
                                <Box sx={{
                                    width: "100%", margin: "auto", backgroundColor: "white", border: "2px solid #B56E2C",
                                    borderRadius: "10px", boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.1)", padding: "30px", textAlign: "start"
                                }}>
                                    <Typography sx={{ ...FontStyles.faqphg }}>

                                        you can find my album option on the left side of the page . when you click on it you get an option like add photo by clicking on it; a pop-up appears where you can upload your photos.
                                    </Typography>
                                </Box>
                            </Card>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion expanded={expanded === "panel14"} onChange={handleChange("panel14")} sx={{ backgroundColor: "rgba(247, 242, 242, 0.8)", mb: 2, color: "black" }}>
                        <AccordionSummary
                            expandIcon={expanded === "panel14" ? <RemoveIcon sx={{ color: "black" }} /> : <AddIcon sx={{ color: "black" }} />}
                        >

                            <Typography sx={{ ...FontStyles.faqfontstyle }}>
                                how can i shortlist profile ?
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Card sx={{ ...styles.faqcard, height: "auto", width: "100%", padding: 4, borderRadius: "5px" }}>
                                <DecorativeCorner sx={{ top: -20, left: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ top: -20, right: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ bottom: -20, right: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ bottom: -20, left: -20, transform: "rotate(0deg)" }} />
                                <Box sx={{
                                    width: "100%", margin: "auto", backgroundColor: "white", border: "2px solid #B56E2C",
                                    borderRadius: "10px", boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.1)", padding: "30px", textAlign: "start"
                                }}>
                                    <Typography sx={{ ...FontStyles.faqphg }}>

                                        you can find more button on the right side of the profile where you have option to shortlist the profile. by clicking on it you can shortlist the Profile
                                    </Typography>
                                </Box>
                            </Card>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion expanded={expanded === "panel15"} onChange={handleChange("panel15")} sx={{ backgroundColor: "rgba(247, 242, 242, 0.8)", mb: 2, color: "black" }}>
                        <AccordionSummary
                            expandIcon={expanded === "panel15" ? <RemoveIcon sx={{ color: "black" }} /> : <AddIcon sx={{ color: "black" }} />}
                        >

                            <Typography sx={{ ...FontStyles.faqfontstyle }}>
                                how can i blocklist profile ?
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Card sx={{ ...styles.faqcard, height: "auto", width: "100%", padding: 4, borderRadius: "5px" }}>
                                <DecorativeCorner sx={{ top: -20, left: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ top: -20, right: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ bottom: -20, right: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ bottom: -20, left: -20, transform: "rotate(0deg)" }} />
                                <Box sx={{
                                    width: "100%", margin: "auto", backgroundColor: "white", border: "2px solid #B56E2C",
                                    borderRadius: "10px", boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.1)", padding: "30px", textAlign: "start"
                                }}>
                                    <Typography sx={{ ...FontStyles.faqphg }}>

                                        you can find more button on the right side of the profile where you have option to blocklist the profile. by clicking on it you can blocklist the Profile
                                    </Typography>
                                </Box>
                            </Card>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion expanded={expanded === "panel16"} onChange={handleChange("panel16")} sx={{ backgroundColor: "rgba(247, 242, 242, 0.8)", mb: 2, color: "black" }}>
                        <AccordionSummary
                            expandIcon={expanded === "panel16" ? <RemoveIcon sx={{ color: "black" }} /> : <AddIcon sx={{ color: "black" }} />}
                        >

                            <Typography sx={{ ...FontStyles.faqfontstyle }}>
                                how can i send interest to the  profile ?
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Card sx={{ ...styles.faqcard, height: "auto", width: "100%", padding: 4, borderRadius: "5px" }}>
                                <DecorativeCorner sx={{ top: -20, left: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ top: -20, right: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ bottom: -20, right: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ bottom: -20, left: -20, transform: "rotate(0deg)" }} />
                                <Box sx={{
                                    width: "100%", margin: "auto", backgroundColor: "white", border: "2px solid #B56E2C",
                                    borderRadius: "10px", boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.1)", padding: "30px", textAlign: "start"
                                }}>
                                    <Typography sx={{ ...FontStyles.faqphg }}>

                                        you can find more button on the right side of the profile where you have option to send interest to  the profile. by clicking on it you cansend interest to the Profile
                                    </Typography>
                                </Box>
                            </Card>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion expanded={expanded === "panel33"} onChange={handleChange("panel33")} sx={{ backgroundColor: "rgba(247, 242, 242, 0.8)", mb: 2, color: "black" }}>
                        <AccordionSummary
                            expandIcon={expanded === "panel33" ? <RemoveIcon sx={{ color: "black" }} /> : <AddIcon sx={{ color: "black" }} />}
                        >

                            <Typography sx={{ ...FontStyles.faqfontstyle }}>
                                how can i view shortlistd  profile ?
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Card sx={{ ...styles.faqcard, height: "auto", width: "100%", padding: 4, borderRadius: "5px" }}>
                                <DecorativeCorner sx={{ top: -20, left: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ top: -20, right: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ bottom: -20, right: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ bottom: -20, left: -20, transform: "rotate(0deg)" }} />
                                <Box sx={{
                                    width: "100%", margin: "auto", backgroundColor: "white", border: "2px solid #B56E2C",
                                    borderRadius: "10px", boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.1)", padding: "30px", textAlign: "start"
                                }}>
                                    <Typography sx={{ ...FontStyles.faqphg }}>

                                        at the top of the page you have filed like comunity ,matched ,shortlisted ,blocklisted,profile i viewed who viewed my profile on clicking shortlisted you can view shortlisted profiles
                                    </Typography>
                                </Box>
                            </Card>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion expanded={expanded === "panel34"} onChange={handleChange("panel34")} sx={{ backgroundColor: "rgba(247, 242, 242, 0.8)", mb: 2, color: "black" }}>
                        <AccordionSummary
                            expandIcon={expanded === "panel34" ? <RemoveIcon sx={{ color: "black" }} /> : <AddIcon sx={{ color: "black" }} />}
                        >

                            <Typography sx={{ ...FontStyles.faqfontstyle }}>
                                how can i view Blocklisted  profile ?
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Card sx={{ ...styles.faqcard, height: "auto", width: "100%", padding: 4, borderRadius: "5px" }}>
                                <DecorativeCorner sx={{ top: -20, left: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ top: -20, right: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ bottom: -20, right: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ bottom: -20, left: -20, transform: "rotate(0deg)" }} />
                                <Box sx={{
                                    width: "100%", margin: "auto", backgroundColor: "white", border: "2px solid #B56E2C",
                                    borderRadius: "10px", boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.1)", padding: "30px", textAlign: "start"
                                }}>
                                    <Typography sx={{ ...FontStyles.faqphg }}>

                                        at the top of the page you have filed like comunity ,matched , shortlisted  ,blocklisted,profile i viewed who viewed my profile on clicking blocklistd you can view blocklistd profiles
                                    </Typography>
                                </Box>
                            </Card>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion expanded={expanded === "panel17"} onChange={handleChange("panel17")} sx={{ backgroundColor: "rgba(247, 242, 242, 0.8)", mb: 2, color: "black" }}>
                        <AccordionSummary
                            expandIcon={expanded === "panel17" ? <RemoveIcon sx={{ color: "black" }} /> : <AddIcon sx={{ color: "black" }} />}
                        >

                            <Typography sx={{ ...FontStyles.faqfontstyle }}>
                                what is 'profiles i viewed'?
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Card sx={{ ...styles.faqcard, height: "auto", width: "100%", padding: 4, borderRadius: "5px" }}>
                                <DecorativeCorner sx={{ top: -20, left: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ top: -20, right: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ bottom: -20, right: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ bottom: -20, left: -20, transform: "rotate(0deg)" }} />
                                <Box sx={{
                                    width: "100%", margin: "auto", backgroundColor: "white", border: "2px solid #B56E2C",
                                    borderRadius: "10px", boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.1)", padding: "30px", textAlign: "start"
                                }}>
                                    <Typography sx={{ ...FontStyles.faqphg }}>

                                        'profile i viewed 'option is those member profiles which you have viewed previously                                   </Typography>
                                </Box>
                            </Card>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion expanded={expanded === "panel18"} onChange={handleChange("panel18")} sx={{ backgroundColor: "rgba(247, 242, 242, 0.8)", mb: 2, color: "black" }}>
                        <AccordionSummary
                            expandIcon={expanded === "panel18" ? <RemoveIcon sx={{ color: "black" }} /> : <AddIcon sx={{ color: "black" }} />}
                        >

                            <Typography sx={{ ...FontStyles.faqfontstyle }}>
                                what is 'viewed my Profile'?
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Card sx={{ ...styles.faqcard, height: "auto", width: "100%", padding: 4, borderRadius: "5px" }}>
                                <DecorativeCorner sx={{ top: -20, left: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ top: -20, right: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ bottom: -20, right: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ bottom: -20, left: -20, transform: "rotate(0deg)" }} />
                                <Box sx={{
                                    width: "100%", margin: "auto", backgroundColor: "white", border: "2px solid #B56E2C",
                                    borderRadius: "10px", boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.1)", padding: "30px", textAlign: "start"
                                }}>
                                    <Typography sx={{ ...FontStyles.faqphg }}>

                                        'viewed my profile ' option is those members who had viewed your profile will appear in this tab
                                    </Typography>
                                </Box>
                            </Card>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion expanded={expanded === "panel19"} onChange={handleChange("panel19")} sx={{ backgroundColor: "rgba(247, 242, 242, 0.8)", mb: 2, color: "black" }}>
                        <AccordionSummary
                            expandIcon={expanded === "panel19" ? <RemoveIcon sx={{ color: "black" }} /> : <AddIcon sx={{ color: "black" }} />}
                        >

                            <Typography sx={{ ...FontStyles.faqfontstyle }}>
                                what is 'interest sent'?
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Card sx={{ ...styles.faqcard, height: "auto", width: "100%", padding: 4, borderRadius: "5px" }}>
                                <DecorativeCorner sx={{ top: -20, left: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ top: -20, right: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ bottom: -20, right: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ bottom: -20, left: -20, transform: "rotate(0deg)" }} />
                                <Box sx={{
                                    width: "100%", margin: "auto", backgroundColor: "white", border: "2px solid #B56E2C",
                                    borderRadius: "10px", boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.1)", padding: "30px", textAlign: "start"
                                }}>
                                    <Typography sx={{ ...FontStyles.faqphg }}>

                                        for those profiles, which you have sent interest ,only those profiles appear in this tab                   </Typography>
                                </Box>
                            </Card>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion expanded={expanded === "panel20"} onChange={handleChange("panel20")} sx={{ backgroundColor: "rgba(247, 242, 242, 0.8)", mb: 2, color: "black" }}>
                        <AccordionSummary
                            expandIcon={expanded === "panel20" ? <RemoveIcon sx={{ color: "black" }} /> : <AddIcon sx={{ color: "black" }} />}
                        >

                            <Typography sx={{ ...FontStyles.faqfontstyle }}>
                                what is 'interest Recevied'?
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Card sx={{ ...styles.faqcard, height: "auto", width: "100%", padding: 4, borderRadius: "5px" }}>
                                <DecorativeCorner sx={{ top: -20, left: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ top: -20, right: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ bottom: -20, right: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ bottom: -20, left: -20, transform: "rotate(0deg)" }} />
                                <Box sx={{
                                    width: "100%", margin: "auto", backgroundColor: "white", border: "2px solid #B56E2C",
                                    borderRadius: "10px", boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.1)", padding: "30px", textAlign: "start"
                                }}>
                                    <Typography sx={{ ...FontStyles.faqphg }}>

                                        profiles from which you have received interest appear in this tab
                                    </Typography>                                </Box>
                            </Card>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion expanded={expanded === "panel21"} onChange={handleChange("panel21")} sx={{ backgroundColor: "rgba(247, 242, 242, 0.8)", mb: 2, color: "black" }}>
                        <AccordionSummary
                            expandIcon={expanded === "panel21" ? <RemoveIcon sx={{ color: "black" }} /> : <AddIcon sx={{ color: "black" }} />}
                        >

                            <Typography sx={{ ...FontStyles.faqfontstyle }}>
                                what is 'viewed Contacts'?
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Card sx={{ ...styles.faqcard, height: "auto", width: "100%", padding: 4, borderRadius: "5px" }}>
                                <DecorativeCorner sx={{ top: -20, left: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ top: -20, right: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ bottom: -20, right: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ bottom: -20, left: -20, transform: "rotate(0deg)" }} />
                                <Box sx={{
                                    width: "100%", margin: "auto", backgroundColor: "white", border: "2px solid #B56E2C",
                                    borderRadius: "10px", boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.1)", padding: "30px", textAlign: "start"
                                }}>
                                    <Typography sx={{ ...FontStyles.faqphg }}>

                                        nothing</Typography>                                </Box>
                            </Card>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion expanded={expanded === "panel22"} onChange={handleChange("panel22")} sx={{ backgroundColor: "rgba(247, 242, 242, 0.8)", mb: 2, color: "black" }}>
                        <AccordionSummary
                            expandIcon={expanded === "panel22" ? <RemoveIcon sx={{ color: "black" }} /> : <AddIcon sx={{ color: "black" }} />}
                        >

                            <Typography sx={{ ...FontStyles.faqfontstyle }}>
                                where can i view interest sent and interest received profiles
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Card sx={{ ...styles.faqcard, height: "auto", width: "100%", padding: 4, borderRadius: "5px" }}>
                                <DecorativeCorner sx={{ top: -20, left: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ top: -20, right: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ bottom: -20, right: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ bottom: -20, left: -20, transform: "rotate(0deg)" }} />
                                <Box sx={{
                                    width: "100%", margin: "auto", backgroundColor: "white", border: "2px solid #B56E2C",
                                    borderRadius: "10px", boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.1)", padding: "30px", textAlign: "start"
                                }}>
                                    <Typography sx={{ ...FontStyles.faqphg }}>

                                        at the left side of the page , you have option interest sent and interest received on click it ,you can find those profiles</Typography>                                </Box>
                            </Card>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion expanded={expanded === "panel23"} onChange={handleChange("panel23")} sx={{ backgroundColor: "rgba(247, 242, 242, 0.8)", mb: 2, color: "black" }}>
                        <AccordionSummary
                            expandIcon={expanded === "panel23" ? <RemoveIcon sx={{ color: "black" }} /> : <AddIcon sx={{ color: "black" }} />}
                        >

                            <Typography sx={{ ...FontStyles.faqfontstyle }}>
                                what is quick search?
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Card sx={{ ...styles.faqcard, height: "auto", width: "100%", padding: 4, borderRadius: "5px" }}>
                                <DecorativeCorner sx={{ top: -20, left: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ top: -20, right: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ bottom: -20, right: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ bottom: -20, left: -20, transform: "rotate(0deg)" }} />
                                <Box sx={{
                                    width: "100%", margin: "auto", backgroundColor: "white", border: "2px solid #B56E2C",
                                    borderRadius: "10px", boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.1)", padding: "30px", textAlign: "start"
                                }}>
                                    <Typography sx={{ ...FontStyles.faqphg }}>

                                        at the left side of the page , you have option interest sent and interest received on click it ,you can find those profiles</Typography>                                </Box>
                            </Card>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion expanded={expanded === "panel24"} onChange={handleChange("panel24")} sx={{ backgroundColor: "rgba(247, 242, 242, 0.8)", mb: 2, color: "black" }}>
                        <AccordionSummary
                            expandIcon={expanded === "panel24" ? <RemoveIcon sx={{ color: "black" }} /> : <AddIcon sx={{ color: "black" }} />}
                        >

                            <Typography sx={{ ...FontStyles.faqfontstyle }}>
                                what is Advance search?
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Card sx={{ ...styles.faqcard, height: "auto", width: "100%", padding: 4, borderRadius: "5px" }}>
                                <DecorativeCorner sx={{ top: -20, left: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ top: -20, right: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ bottom: -20, right: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ bottom: -20, left: -20, transform: "rotate(0deg)" }} />
                                <Box sx={{
                                    width: "100%", margin: "auto", backgroundColor: "white", border: "2px solid #B56E2C",
                                    borderRadius: "10px", boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.1)", padding: "30px", textAlign: "start"
                                }}>
                                    <Typography sx={{ ...FontStyles.faqphg }}>

                                        this is a detailed search and will give you better results. options on profession ,education,marital status,annual income ,caste ,sub-caste mother-tongue ,contry living in ,start,smoke,drink,complexion ,dosham,profiles with photo and results will be dispayed.
                                    </Typography>                                </Box>
                            </Card>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion expanded={expanded === "panel25"} onChange={handleChange("panel25")} sx={{ backgroundColor: "rgba(247, 242, 242, 0.8)", mb: 2, color: "black" }}>
                        <AccordionSummary
                            expandIcon={expanded === "panel25" ? <RemoveIcon sx={{ color: "black" }} /> : <AddIcon sx={{ color: "black" }} />}
                        >

                            <Typography sx={{ ...FontStyles.faqfontstyle }}>
                                what is id  search?
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Card sx={{ ...styles.faqcard, height: "auto", width: "100%", padding: 4, borderRadius: "5px" }}>
                                <DecorativeCorner sx={{ top: -20, left: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ top: -20, right: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ bottom: -20, right: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ bottom: -20, left: -20, transform: "rotate(0deg)" }} />
                                <Box sx={{
                                    width: "100%", margin: "auto", backgroundColor: "white", border: "2px solid #B56E2C",
                                    borderRadius: "10px", boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.1)", padding: "30px", textAlign: "start"
                                }}>
                                    <Typography sx={{ ...FontStyles.faqphg }}>

                                        enter the annapurnamarriages id of the member whose profile you would like to see. click on search limk.                                        </Typography>                                </Box>
                            </Card>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion expanded={expanded === "panel26"} onChange={handleChange("panel26")} sx={{ backgroundColor: "rgba(247, 242, 242, 0.8)", mb: 2, color: "black" }}>
                        <AccordionSummary
                            expandIcon={expanded === "panel26" ? <RemoveIcon sx={{ color: "black" }} /> : <AddIcon sx={{ color: "black" }} />}
                        >

                            <Typography sx={{ ...FontStyles.faqfontstyle }}>
                                how can i upgrade my profile
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Card sx={{ ...styles.faqcard, height: "auto", width: "100%", padding: 4, borderRadius: "5px" }}>
                                <DecorativeCorner sx={{ top: -20, left: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ top: -20, right: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ bottom: -20, right: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ bottom: -20, left: -20, transform: "rotate(0deg)" }} />
                                <Box sx={{
                                    width: "100%", margin: "auto", backgroundColor: "white", border: "2px solid #B56E2C",
                                    borderRadius: "10px", boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.1)", padding: "30px", textAlign: "start"
                                }}>
                                    <Typography sx={{ ...FontStyles.faqphg }}>

                                        nothing
                                    </Typography>                                </Box>
                            </Card>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion expanded={expanded === "panel27"} onChange={handleChange("panel27")} sx={{ backgroundColor: "rgba(247, 242, 242, 0.8)", mb: 2, color: "black" }}>
                        <AccordionSummary
                            expandIcon={expanded === "panel27" ? <RemoveIcon sx={{ color: "black" }} /> : <AddIcon sx={{ color: "black" }} />}
                        >

                            <Typography sx={{ ...FontStyles.faqfontstyle }}>
                                what are the different modes of payment ?
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Card sx={{ ...styles.faqcard, height: "auto", width: "100%", padding: 4, borderRadius: "5px" }}>
                                <DecorativeCorner sx={{ top: -20, left: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ top: -20, right: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ bottom: -20, right: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ bottom: -20, left: -20, transform: "rotate(0deg)" }} />
                                <Box sx={{
                                    width: "100%", margin: "auto", backgroundColor: "white", border: "2px solid #B56E2C",
                                    borderRadius: "10px", boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.1)", padding: "30px", textAlign: "start"
                                }}>
                                    <Typography sx={{ ...FontStyles.faqphg }}>

                                        nothing
                                    </Typography>                                </Box>
                            </Card>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion expanded={expanded === "panel28"} onChange={handleChange("panel28")} sx={{ backgroundColor: "rgba(247, 242, 242, 0.8)", mb: 2, color: "black" }}>
                        <AccordionSummary
                            expandIcon={expanded === "panel28" ? <RemoveIcon sx={{ color: "black" }} /> : <AddIcon sx={{ color: "black" }} />}
                        >

                            <Typography sx={{ ...FontStyles.faqfontstyle }}>
                                what are the packages available for your paid services  ?
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Card sx={{ ...styles.faqcard, height: "auto", width: "100%", padding: 4, borderRadius: "5px" }}>
                                <DecorativeCorner sx={{ top: -20, left: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ top: -20, right: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ bottom: -20, right: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ bottom: -20, left: -20, transform: "rotate(0deg)" }} />
                                <Box sx={{
                                    width: "100%", margin: "auto", backgroundColor: "white", border: "2px solid #B56E2C",
                                    borderRadius: "10px", boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.1)", padding: "30px", textAlign: "start"
                                }}>
                                    <Typography sx={{ ...FontStyles.faqphg }}>

                                        nothing
                                    </Typography>                                </Box>
                            </Card>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion expanded={expanded === "panel29"} onChange={handleChange("panel29")} sx={{ backgroundColor: "rgba(247, 242, 242, 0.8)", mb: 2, color: "black" }}>
                        <AccordionSummary
                            expandIcon={expanded === "panel29" ? <RemoveIcon sx={{ color: "black" }} /> : <AddIcon sx={{ color: "black" }} />}
                        >

                            <Typography sx={{ ...FontStyles.faqfontstyle }}>
                                what are the assisted services you provide for your paid services  ?
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Card sx={{ ...styles.faqcard, height: "auto", width: "100%", padding: 4, borderRadius: "5px" }}>
                                <DecorativeCorner sx={{ top: -20, left: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ top: -20, right: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ bottom: -20, right: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ bottom: -20, left: -20, transform: "rotate(0deg)" }} />
                                <Box sx={{
                                    width: "100%", margin: "auto", backgroundColor: "white", border: "2px solid #B56E2C",
                                    borderRadius: "10px", boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.1)", padding: "30px", textAlign: "start"
                                }}>
                                    <Typography sx={{ ...FontStyles.faqphg }}>

                                        nothing
                                    </Typography>                                </Box>
                            </Card>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion expanded={expanded === "panel30"} onChange={handleChange("panel30")} sx={{ backgroundColor: "rgba(247, 242, 242, 0.8)", mb: 2, color: "black" }}>
                        <AccordionSummary
                            expandIcon={expanded === "panel30" ? <RemoveIcon sx={{ color: "black" }} /> : <AddIcon sx={{ color: "black" }} />}
                        >

                            <Typography sx={{ ...FontStyles.faqfontstyle }}>
                                how do i change my password?
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Card sx={{ ...styles.faqcard, height: "auto", width: "100%", padding: 4, borderRadius: "5px" }}>
                                <DecorativeCorner sx={{ top: -20, left: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ top: -20, right: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ bottom: -20, right: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ bottom: -20, left: -20, transform: "rotate(0deg)" }} />
                                <Box sx={{
                                    width: "100%", margin: "auto", backgroundColor: "white", border: "2px solid #B56E2C",
                                    borderRadius: "10px", boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.1)", padding: "30px", textAlign: "start"
                                }}>
                                    <Typography sx={{ ...FontStyles.faqphg }}>

                                        after login go to change password section ,enter your new password and confirm it your password will be changed.
                                    </Typography>                                </Box>
                            </Card>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion expanded={expanded === "panel31"} onChange={handleChange("panel31")} sx={{ backgroundColor: "rgba(247, 242, 242, 0.8)", mb: 2, color: "black" }}>
                        <AccordionSummary
                            expandIcon={expanded === "panel31" ? <RemoveIcon sx={{ color: "black" }} /> : <AddIcon sx={{ color: "black" }} />}
                        >

                            <Typography sx={{ ...FontStyles.faqfontstyle }}>
                                i forgot my annapurna marriages id/password. what should i do ?
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Card sx={{ ...styles.faqcard, height: "auto", width: "100%", padding: 4, borderRadius: "5px" }}>
                                <DecorativeCorner sx={{ top: -20, left: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ top: -20, right: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ bottom: -20, right: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ bottom: -20, left: -20, transform: "rotate(0deg)" }} />
                                <Box sx={{
                                    width: "100%", margin: "auto", backgroundColor: "white", border: "2px solid #B56E2C",
                                    borderRadius: "10px", boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.1)", padding: "30px", textAlign: "start"
                                }}>
                                    <Typography sx={{ ...FontStyles.faqphg }}>

                                        you can retrieve your annapurna marriages id/password by cliking on forgot password link in home page and enter your email id we will send you an e-mail with your annapurna marriages id and password immediately. your e-mail id should be the one given in your profile
                                    </Typography>                                </Box>
                            </Card>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion expanded={expanded === "panel32"} onChange={handleChange("panel32")} sx={{ backgroundColor: "rgba(247, 242, 242, 0.8)", mb: 2, color: "black" }}>
                        <AccordionSummary
                            expandIcon={expanded === "panel32" ? <RemoveIcon sx={{ color: "black" }} /> : <AddIcon sx={{ color: "black" }} />}
                        >

                            <Typography sx={{ ...FontStyles.faqfontstyle }}>
                                can i chosee my own annapurna marriages id ?
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Card sx={{ ...styles.faqcard, height: "auto", width: "100%", padding: 4, borderRadius: "5px" }}>
                                <DecorativeCorner sx={{ top: -20, left: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ top: -20, right: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ bottom: -20, right: -20, transform: "rotate(0deg)" }} />
                                <DecorativeCorner sx={{ bottom: -20, left: -20, transform: "rotate(0deg)" }} />
                                <Box sx={{
                                    width: "100%", margin: "auto", backgroundColor: "white", border: "2px solid #B56E2C",
                                    borderRadius: "10px", boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.1)", padding: "30px", textAlign: "start"
                                }}>
                                    <Typography sx={{ ...FontStyles.faqphg }}>

                                        every annapurna marriagesid is unique and is allocated by the system. you cannot choose your own annapurna marriages id since is system generated and cannot be changed under any circumstance
                                    </Typography>                                </Box>
                            </Card>
                        </AccordionDetails>
                    </Accordion>
                </Box>
            </Box>
            <Footer />
        </>
    );
};

export default Faq;
